import { IconProps } from 'src/utils/icon';

function PlusIcon({ size = 1, fill = '#2c2a29' }: IconProps) {
  return (
    <svg
      style={{ fontSize: `${size}rem` }}
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0625 0.749985H11.9375C12.1042 0.749985 12.1875 0.833318 12.1875 0.999985V23C12.1875 23.1667 12.1042 23.25 11.9375 23.25H10.0625C9.89583 23.25 9.8125 23.1667 9.8125 23V0.999985C9.8125 0.833318 9.89583 0.749985 10.0625 0.749985Z"
        fill="#262626"
      />
      <path
        d="M0.5 10.8125H21.5C21.6667 10.8125 21.75 10.8958 21.75 11.0625V12.9375C21.75 13.1042 21.6667 13.1875 21.5 13.1875H0.5C0.333333 13.1875 0.25 13.1042 0.25 12.9375V11.0625C0.25 10.8958 0.333333 10.8125 0.5 10.8125Z"
        fill="#262626"
      />
    </svg>
  );
}

export default PlusIcon;
